"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LvToAllianzUKTransferBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var LvToAllianzUKTransferBanner = /** @class */ (function (_super) {
    __extends(LvToAllianzUKTransferBanner, _super);
    function LvToAllianzUKTransferBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isBannerEnabled: false,
            wording: undefined
        };
        return _this;
    }
    LvToAllianzUKTransferBanner.prototype.componentDidMount = function () {
        var _this = this;
        this.falconConvenienceApiService.getSettings().subscribe(function (settings) { return services_1.LvToAllianzUKTransferBannerHelper.setBannerWidgetState(settings, function (state) { return _this.setState(state); }); });
    };
    LvToAllianzUKTransferBanner.prototype.render = function () {
        if (!this.state.isBannerEnabled) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "banner mt-5 negative-mb-10", children: (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsxs)("p", { className: "fs-20", children: [this.state.wording, " You can find out more information about the transfer at ", ' ', (0, jsx_runtime_1.jsx)("a", { className: "font-weight-normal", href: "https://www.allianz.co.uk/transfer", id: "transfer", target: "_blank", children: "www.allianz.co.uk/transfer" }), "."] }) }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], LvToAllianzUKTransferBanner.prototype, "falconConvenienceApiService", void 0);
    return LvToAllianzUKTransferBanner;
}(React.Component));
exports.LvToAllianzUKTransferBanner = LvToAllianzUKTransferBanner;
//# sourceMappingURL=LvToAllianzUKTransferBanner.js.map